import React, { useState, useEffect, useCallback } from 'react';
import Header from '../components/Header';
import SearchBar from '../components/SearchBar';
import PostGrid from '../components/PostGrid';
import Pagination from '../components/Pagination';
import Footer from '../components/Footer';
import { getPosts, getAllTags } from '../api/api';
import './HomePage.css';

const HomePage = () => {
  const [posts, setPosts] = useState([]);
  const [page, setPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [totalElements, setTotalElements] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [category, setCategory] = useState('all');
  const [tag, setTag] = useState('');
  const [search, setSearch] = useState('');
  const [tags, setTags] = useState([]);
  const [loading, setLoading] = useState(true);

  const pageSize = 15;

  const fetchPosts = useCallback(async () => {
    setLoading(true);
    try {
      const params = { page, size: pageSize };
      if (category && category !== 'all') params.category = category;
      if (tag) params.tag = tag;
      if (search) params.search = search;

      const data = await getPosts(params);
      setPosts(data.posts || []);
      setTotalPages(data.totalPages || 0);
      setTotalElements(data.totalElements || 0);
      setTotalCount(data.totalCount || 0);
    } catch (err) {
      console.error('Failed to fetch posts:', err);
      setPosts([]);
    } finally {
      setLoading(false);
    }
  }, [page, category, tag, search]);

  useEffect(() => {
    fetchPosts();
  }, [fetchPosts]);

  useEffect(() => {
    getAllTags()
      .then(setTags)
      .catch(() => setTags([]));
  }, []);

  const handleCategoryChange = (cat) => {
    setCategory(cat);
    setPage(0);
  };

  const handleTagChange = (t) => {
    setTag(t);
    setPage(0);
  };

  const handleSearchChange = (s) => {
    setSearch(s);
    setPage(0);
  };

  const handleReset = () => {
    setCategory('all');
    setTag('');
    setSearch('');
    setPage(0);
  };

  return (
    <div className="home-page">
      <Header activeCategory={category} onCategoryChange={handleCategoryChange} />

      <SearchBar
        search={search}
        onSearchChange={handleSearchChange}
        selectedTag={tag}
        onTagChange={handleTagChange}
        tags={tags}
        totalElements={totalElements}
        totalCount={totalCount}
        onReset={handleReset}
      />

      {loading ? (
        <div className="loading-indicator">yükleniyor...</div>
      ) : (
        <PostGrid posts={posts} />
      )}

      <Pagination
        currentPage={page}
        totalPages={totalPages}
        totalElements={totalElements}
        pageSize={pageSize}
        onPageChange={setPage}
      />

      <Footer />
    </div>
  );
};

export default HomePage;
